// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import moment from 'moment'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { formatDecimal, handlingPermitServiceCriteria, phoneMasker, isPermissionExist, sortPortalPermissionByKey, getCardIcon, removeDubleComma, shouldShowVehicleColumn, employerDetailsSection } from '../../../utils/helper'

import queryString from 'query-string'
// import { saveBookingAfterPayment } from '../../../redux/actions/paymentActions'
// import { useNavigate } from 'react-router-dom'
// import URL from '../../../constants/urls'
import { Circles } from 'react-loader-spinner'
import { systemError } from '../../../Global/Constant'
import { Col, Row } from 'react-bootstrap'
import useMobileView from '../../../Hooks/useMobileView'


function ThankYou(props) {
  const { response, paymentStatus, paymentResponse, isLoading, partnerDetails } = props
  const [bookingType, setBookingType] = useState('')
  const [paymentSession, setPaymentSession] = useState(EMPTY_OBJECT)
  const [queries, setQueries] = useState(EMPTY_OBJECT)
  // const navigate = useNavigate()
  const partner = window.location.toString().split('/')[3]
  const zone = localStorage.getItem('zone')
  const [accessPermissions, setAccessPermissions] = useState('')
  const [isphone, setIsPhone] = useState('')
  const CardNumberLast4 = localStorage.getItem('CardNumberLast4') ? localStorage.getItem('CardNumberLast4') : ''
  const expiration_date = localStorage.getItem('expiration_date') ? localStorage.getItem('expiration_date') : ''
  const card_type = localStorage.getItem('card_type') ? localStorage.getItem('card_type') : ''
  const [isDisplayFacility, setIsDisplayFacility] = useState(false) //PIMS-11105
  const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
  const [displayVehicle, setDisplayVehicle] = useState(false)
  const isMobile = useMobileView()

  useEffect(() => {

    //setPage('thankyou')
    window.scrollTo(0, 0)
    let queries = queryString.parse(location.search)
    const bookTypeData = localStorage.getItem('bookingType')
    setBookingType(bookTypeData)
    setQueries(queries)
    // const beforePaymentPayload = JSON.parse(localStorage.getItem('beforePaymentPayloadValue'))
    const paymentSession = localStorage.getItem('paymentSession') ? JSON.parse(localStorage.getItem('paymentSession')) : null
    setPaymentSession(paymentSession)
    // const payloadafterPayment = {
    // 	'facility_id': beforePaymentPayload?.facility_id,
    // 	'license_number': beforePaymentPayload?.license_number,
    // 	'first_name': beforePaymentPayload?.firstname,
    // 	'last_name': beforePaymentPayload?.lastname,
    // 	'password': beforePaymentPayload?.password ? beforePaymentPayload?.password : '',
    // 	'confirm_password': beforePaymentPayload?.cpassword ? beforePaymentPayload?.cpassword : '',
    // 	'email': beforePaymentPayload?.email,
    // 	'phone': beforePaymentPayload?.phone,
    // 	'city': beforePaymentPayload?.city,
    // 	'state': beforePaymentPayload?.state,
    // 	'zipcode': beforePaymentPayload?.zipcode,
    // 	'desired_start_date': moment().format('YYYY/MM/DD'),
    // 	'vehicleList': beforePaymentPayload?.vehicleList,
    // 	'is_admin': '0',
    // 	'user_id': beforePaymentPayload?.user_id ? beforePaymentPayload?.user_id : '',
    // 	'address1': beforePaymentPayload?.address1,
    // 	'address2': beforePaymentPayload?.address2 ? beforePaymentPayload?.address2 : '',
    // 	'permit_rate': beforePaymentPayload?.permit_rate,
    // 	'permit_rate_id': beforePaymentPayload?.permit_rate_id,
    // 	'payment_status': 'success',
    // 	'MerchantRef': queries?.MerchantRef ? queries?.MerchantRef : paymentSession?.reference ? paymentSession?.reference : '',
    // 	// TxID : queries?.TxID,
    // 	// CardType: queries?.CardType,
    // 	// total : paymentSession?.amount,
    // 	// TokenNo:queries?.TokenNo,
    // 	// AuthorisationCode: queries?.AuthorisationCode,

    // }

    // if (queries?.AuthorisationCode && queries?.AuthorisationCode !== null && queries?.AuthorisationCode !== '') {
    //setPaymentStatus(true)
    // dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
    // 	if (res?.data && res?.data?.message && res?.data?.message == 'Booking already done by the user.') {
    // 		navigate(`/${partner}${URL?.BASE_HOME}`)
    // 	}
    // 	setPaymentResponse(res)
    // 	setIsLoading(false)
    // 	setPaymentStatus(true)
    // 	if (res?.data && res?.data?.ticketech_code != '') {
    // 		setPaymentStatus(true)
    // 	} else {
    // 		setPaymentStatus(false)
    // 		setIsLoading(false)
    // 	}
    // 	//localStorage.clear()
    // }).catch((err) => {
    // 	if (err.ticketech_code != '') {
    // 		//localStorage.clear()
    // 	} else {
    // 		setPaymentStatus(false)
    // 		setIsLoading(false)
    // 	}
    // })
    // }
    // else {
    // 	setPaymentStatus(false)
    // 	setIsLoading(false)
    // }
    const isExistPhone = paymentResponse?.userDetails?.user?.phone_number ? paymentResponse?.userDetails?.user?.phone_number : paymentResponse?.userDetails?.phone_number ? paymentResponse?.userDetails?.phone_number : ''
    setIsPhone(isExistPhone)
  }, EMPTY_ARRAY)

  // PIMS-11105
  useEffect(() => {
    if (paymentResponse?.permitServices?.some(item => item?.display_facility == 1)) {
      setIsDisplayFacility(true)
    } else {
      setIsDisplayFacility(false)
    }
  }, [paymentResponse])

  useEffect(() => {
    const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
    setAccessPermissions(getAccessPermissionData)
  }, [EMPTY_ARRAY, partnerDetails])



  const handleReBooking = () => {
    window.location.reload(true)
    // (bookingType == 'Pass') ? navigate(`/${partner}${URL?.BASE_PASSCREATE}`) : navigate(`/${partner}${URL?.BASE_HOME}`)


  }

  // console.log('partnerDetails here', JSON.parse(paymentResponse?.vehicleList))

  const handleshowVehicle = () => {
    setDisplayVehicle(!displayVehicle)
  }


  const DisplayField = (label, value) => {
    return <div className="col-6">
      <label className="floatLabel">{label}</label>
      <div className="inputBox">{value || '-'}</div>
    </div>
  }

  const mobileViewVehicleSection = (vehicleListItem = {}, vehicleListIndex, allVehicle) => {
    return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
      {DisplayField('License Plate', vehicleListItem?.license_plate_number || '-')}
      {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicleListItem?.vehicle_type || '-') : null}
      {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicleListItem.make || vehicleListItem.model)
        ? `${vehicleListItem.make ?? ''}${allHaveMst_model && vehicleListItem.model ? ` / ${vehicleListItem.model}` : ''}`
        : '-' || '-') : null}
      {/* {is_modal_show ? DisplayField('Model', vehicleListItem?.model || '-') : null} */}
      {shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicleListItem?.color || '-') : null}
      {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicleListItem?.style || '-') : null}

      {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicleListItem?.country || '-') : null}
      {shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicleListItem?.state_code || '-') : null}
      {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicleListItem?.vehicle_number || '-') : null}
    </div>
  }

  const renderVehicleRow = (vehicle = {}, i, allVehicle) => {
    return (
      <tr key={i}>
        <td className="px-0">{vehicle.license_plate_number || '-'}</td>
        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
          <td className="px-0">{vehicle.vehicle_type || '-'}</td>
        )}
        {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
          {(vehicle.make || vehicle.model)
            ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
            : '-'}
        </td> : null}
        {shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
          <td className="px-0">{vehicle.style || '-'}</td>
        )}
        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
          <td className="px-0">{vehicle.country || '-'}</td>
        )}
        {shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
        {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
          <td className="px-0">{vehicle.vehicle_number || '-'}</td>
        )}
      </tr>
    )
  }

  const deskTopViewVehicleSection = () => {
    const refractedVehicleList = paymentResponse?.vehicleList
    return <div className='table-responsive'>
      <table className="table table-borderless table-sm mb-0">
        <thead>
          <tr>
            <th className="fw-bold px-0">License Plate</th>
            {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_type') && (
              <th className="fw-bold px-0">Vehicle Type</th>
            )}
            {shouldShowVehicleColumn(refractedVehicleList, 'make') && shouldShowVehicleColumn(refractedVehicleList, 'model') ? <th className="fw-bold px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
            {shouldShowVehicleColumn(refractedVehicleList, 'color') ? <th className="fw-bold px-0">Color</th> : null}
            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(refractedVehicleList, 'style') && (
              <th className="fw-bold px-0">Style</th>
            )}
            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(refractedVehicleList, 'country') && (
              <th className="fw-bold px-0">Country</th>
            )}
            {shouldShowVehicleColumn(refractedVehicleList, 'state_code') ? <th className="fw-bold px-0">State</th> : null}
            {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_number') && (
              <th className="fw-bold px-0">VIN</th>
            )}
          </tr>
        </thead>

        <tbody>
          {renderVehicleRow(refractedVehicleList?.[0], 0, refractedVehicleList)}
        </tbody>

        <tbody className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
          {(refractedVehicleList?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, refractedVehicleList))}
        </tbody>
      </table>
    </div>
  }

  return (
    isLoading ? <span className='ms-2 d-flex justify-content-center'><Circles
      height="500"
      width="50"
      color="var(--bs-primary)"
      ariaLabel="circles-loading"
      visible={true}
    /></span> :
      <div>
        {paymentStatus ?
          <div className="mt-3 ">
            <h1 className="text-success text-center fw-bold mb-3 m-0">Thank You!</h1>
            <p className="text-dark h4 fw-light text-center mb-3 p-4  bg-success bg-opacity-10 "><i className='fa text-success fa-check-circle me-2'></i> Your Parking Permit Request has been submitted and is currently being reviewed.</p>


            <div className='border border-3 '>
              <div className=' px-4  pt-2'>
                <h4 className='fw-semibold text-muted'>Request Details </h4>
                <div className='bg-primary bg-opacity-10'>
                  <div className='row gap-2 py-2 px-3  mb-3 g-0 border-white justify-content-between'>

                    {/* PIMS-11105 */}
                    {(isPermissionExist(accessPermissions, 'Hide Facility') && !isDisplayFacility) ? null : <div className='col-sm col-12'>
                      {/* {(isPermissionExist(accessPermissions, 'Hide Facility')) ? null : <div className='col-sm col-12'> */}
                      <div className='d-flex'>
                        <b className='nowrap'>Facility Name -</b>
                        <span>    {paymentResponse?.facility?.full_name}</span>
                      </div>

                    </div>}
                    <div className='col-sm-auto border-2 border-sm-start border-dark'>
                      <div className='d-flex gap-2 '>

                        <b className='border-left nowrap mr-sm-3'>Reference ID - </b>
                        <span>   {paymentResponse?.tracking_code}</span>
                      </div>

                    </div>
                  </div>
                </div>


                <div className='px-3'>
                  <table className='table table-sm table-borderless tableBlockSM  table-sm'>
                    <tr>
                      <td className='fw-bold'>Name</td>

                      <td>{paymentResponse?.name}</td>

                      <td className='fw-bold'>Email</td>

                      <td>{paymentResponse?.email}</td>
                    </tr>
                    <tr>
                      <td className='fw-bold'>Phone</td>

                      <td>{paymentResponse?.phone && paymentResponse?.phone != '' ? phoneMasker(paymentResponse?.phone) : '-'}</td>

                      <td className='fw-bold'>Permit Type </td>
                      <td>
                        <span className='text-muted me-2'>{paymentResponse?.permit_type_name}</span>
                        <span className="timeValidationRes col-12 small text-primary">{paymentResponse?.rate_description?.is_hide_validity == '0' && paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</span>
                        {/* {paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})`:''} */}
                      </td>

                      {/* <td>{paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</td> */}
                    </tr>
                    {paymentResponse?.reserved_space_number ? <tr>
                      <td className='fw-bold'>Preferred Reserved Space Number</td>

                      <td colSpan='3'>{paymentResponse?.reserved_space_number}</td>
                    </tr> : null }

                  </table>
                  {paymentResponse?.permitServices?.length > 0 ? <div className='py-2 border-top'>
                    <b>Permit Services(s)</b>

                    {paymentResponse?.permitServices?.map((v, i) => {
                      if (v?.permit_service_name != 'Select All Access') {
                        return (

                          <div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
                            {/* <div className=' text-muted text-capitalize' >
                                            {v?.permit_service_name}
                                        </div> */}
                            <div>
                              <span className='text-muted text-capitalize me-2'>{v?.permit_service_name}</span>
                              <span className="timeValidationRes small text-primary">{(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}</span>
                              {/* <span className=' text-muted text-capitalize'>{v?.permit_service_name} {(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}</span> */}
                            </div>
                            {/* <div className='fw-semibold '>
                                            ${v?.permit_service_rate}
                                        </div> */}
                          </div>
                        )
                      }

                    })}
                  </div> : ''}

                </div>
                {employerDetailsSection(paymentResponse?.employerDetails)}
                {/*  price section */}
                {paymentResponse?.vehicleList?.length > 0 ? <div className="border-top container py-2">
                  <div className="d-flex align-items-center mb-2 justify-content-between">
                    <b>Vehicle(s)</b>
                    {paymentResponse?.vehicleList?.length > 1 && (
                      <div className='d-flex gap-2'>
                        <span className='fw-bold text-primary'>
                          {`${paymentResponse?.vehicleList?.length} ${paymentResponse?.vehicleList?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
                        </span>
                        <button
                          className='btn btn-outline-dark btn-sm'
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target='#vehicleCollapse'
                          aria-expanded={displayVehicle}
                          aria-controls='vehicleCollapse'
                          onClick={handleshowVehicle}
                        >
                          {displayVehicle ? 'Hide All' : 'View All'}
                        </button>
                      </div>
                    )}
                  </div>
                    {isMobile ? 
                    <div>
                      <div>
                        {mobileViewVehicleSection(paymentResponse?.vehicleList?.[0], 0, paymentResponse?.vehicleList)}
                      </div>

                      <div className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
                        {(paymentResponse?.vehicleList?.slice(1) || []).map((v, i) => mobileViewVehicleSection(v, i + 1, paymentResponse?.vehicleList))}
                      </div>
                    </div> : deskTopViewVehicleSection()}
                </div> : null}
                {/* key card details  */}
                {(paymentResponse?.keycard && (Object.keys(paymentResponse?.keycard || {})?.length > 0)) ? <div className='py-2 border-top border-2'>
                  <Row>
                    <Col><b>Key Card Enabled :</b> Yes</Col>
                    {/* <Col><b>Key Card Name :</b> {paymentResponse?.keycard?.name || '-'}</Col> */}
                    <Col><b>Key Card Amount :</b>  {(paymentResponse?.keycard && paymentResponse?.keycard?.price) ? `$${formatDecimal(paymentResponse?.keycard?.price)}` : '-'}</Col>
                  </Row>
                </div> : null}

                {/* card detilas  */}
                {(formatDecimal(paymentResponse?.permit_final_amount) == formatDecimal(0)) ? '' : <div className='py-2 border-top border-2'>
                  {(paymentResponse?.paymentDetails?.card_last_four || CardNumberLast4) ? <Row>
                      <Col><b>Card last four:</b> {`XXXXXXXXXXXX${CardNumberLast4 ? removeDubleComma(CardNumberLast4) : paymentResponse?.paymentDetails?.card_last_four}`}</Col>
                      <Col><b>Card type:</b> <img src={getCardIcon(card_type ? removeDubleComma(card_type) : paymentResponse?.paymentDetails?.card_type ? paymentResponse?.paymentDetails?.card_type : '')} style={{ width: '30px', padding: '0' }} alt="" /> {/* card_type ? removeDubleComma(card_type) : paymentResponse?.paymentDetails?.card_type */}</Col>
                      <Col><b>Card expiry:</b> {(expiration_date) ? `${removeDubleComma(expiration_date)?.toString()?.substring(0, 2)}/${removeDubleComma(expiration_date)?.toString()?.substring(2, 4)}` : `${paymentResponse?.paymentDetails?.expiry?.toString()?.substring(0, 2)}/${paymentResponse?.paymentDetails?.expiry?.toString()?.substring(2, 4)}`}</Col>
                  </Row> : null}
                </div>}

                {paymentResponse?.drivers && paymentResponse?.drivers?.length > 0 ? <div className='border-top d-block mx-3 pt-2'>
                  <b className=' ' >Driver Details</b>

                  <table cellSpacing="0px" cellPadding="0" className="table table-borderless table-sm">
                    <thead>
                      <tr className="medium">
                        <th className="fw-bold px-0">Driver Name</th>
                        {/* <th className="text-muted small">License Plate</th> */}
                        <th className="fw-bold px-0">Documents</th>

                      </tr>
                    </thead>
                    <tbody>
                      {paymentResponse?.drivers && paymentResponse?.drivers?.length > 0 ? paymentResponse?.drivers?.map((v, i) => {

                        return (
                          <tr key={i}>
                            <td className='fw-bold px-0'>
                              {v?.driver_name}
                            </td>

                            <td className='fw-bold px-0'>
                              {v?.url ? <a href={v?.url} target="_blank" rel="noreferrer" className="fw-bold">View</a> : '-'}
                            </td>
                          </tr>)
                      }) : 'Data Not Found!'}
                    </tbody>
                  </table>


                </div> : null}

              </div>
              <div className=' bg-light px-4 py-2'>
                
                {Number(paymentResponse?.permit_final_amount) > 0 ? <div className='row g-0 justify-content-between border-top'>
                  <div className='col'>
                    <b className='lead fw-bold' >Total Amount</b>
                  </div>
                  <div className='col-auto'>
                    <h3 className='m-0'>${formatDecimal(paymentResponse?.permit_final_amount)}</h3>
                  </div>
                </div> : ''}

              </div>

            </div>






            {response?.data?.permit_doc?.length > 0 ? <div className='border border-3 p-3 px-4'>
              <div className='col-12 row'>
                <div className='col-12'>
                  <span className='fontsize85'>
                    <b>Uploaded Documents:</b>
                  </span>
                </div>

                {response?.data?.permit_doc?.length > 0 ?
                  response?.data?.permit_doc?.map((item, index) => {
                    return (
                      <div className='col-6' key={index}>
                        <span className='d-block'>{item?.doc_name}</span>
                        <a href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='fw-bold'>View</a>
                      </div>
                    )
                  })
                  : <div className='col-12'>
                    <span className='fontsize85'>
                      N/A
                    </span>
                  </div>}

                {/* {console.log(response, 'I am here')} */}
                {response?.data?.permit_doc?.length > 0 ?<div className='border border-3 p-3 px-4'>
                  <div className='col-12 row'>
                    <div className='col-12'>
                      <span className='fontsize85'>
                        <b>Uploaded Documents:</b>
                      </span>
                    </div>

                    {response?.data?.permit_doc?.length > 0 ? 
                      response?.data?.permit_doc?.map((item, index) => {
                        return(
                          <div className='col-6' key={index}>
                            <span className='d-block'>{item?.doc_name}</span>
                            <a href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='fw-bold'>View</a>
                          </div>
                        )
                      })
                    : <div className='col-12'>
                      <span className='fontsize85'>
                        N/A
                      </span>
                    </div>}
                    
                    
                  </div>
                </div> : null }

                <div className='d-flex justify-content-center'>

                  <button type="button" onClick={(e) => handleReBooking(e)} className="btn btn-primary my-3">Go Back to Home</button>

                </div>
              </div>
            </div> : null}


              {/* display none */}
              <div className="text-start d-none ms-4 mb-3">
                <h4>Request Details:</h4>
                <div className="row">
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">

                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0"></span>
                    </div>
                  </div>
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Email:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">{paymentResponse?.email}</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Phone:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">{paymentResponse?.phone}</span>
                    </div>
                  </div>
                  <div className="col-sm-6 row">
                    <div className="col-4 me-0 pe-0 ">
                      <span className="fontsize85">
                        <b>Reference ID:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">{paymentResponse?.tracking_code}</span>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Permit Type:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">{paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</span>
                    </div>
                  </div>
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Permit Amount:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">${formatDecimal(paymentResponse?.permit_rate)}</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Facility:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">{paymentResponse?.facility?.full_name}</span>
                    </div>
                  </div>
                  {paymentResponse?.permit_final_amount ? <div className="col-sm-6 row">
                    <div className="col-4">
                      <span className="fontsize85">
                        <b>Total Amount:</b>
                      </span>
                    </div>
                    <div className="col-8">
                      <span className="fontsize85 ms-0">${paymentResponse?.permit_final_amount}</span>
                    </div>
                  </div> : ''}
                </div>
                <div className="row">
                  <div className="col-12 row">
                    <div className="col-12">
                      <span className="fontsize85">
                        <b>Vehicle:</b>
                      </span>
                    </div>
                    <div className="col-12 table-responsive">
                      <span>
                        <table cellSpacing="0px" cellPadding="0" className="table">
                          <thead>
                            <tr className="small">
                              <th className="text-muted small">License Plate</th>
                              <th className="text-muted small">Make</th>
                              <th className="text-muted small">Model</th>
                              {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th className='text-sm text-zinc-500 text-nowrap py-2 text-left'>Vehicle Type</th> : ''}
                              <th className="text-muted small">Color</th>
                              {isPermissionExist(accessPermissions, 'Get Vehicle Style') ? <th className='text-sm text-zinc-500 text-nowrap py-2 text-left'>Style</th> : ''}
                              <th className="text-muted small">State</th>
                              {(isPermissionExist(accessPermissions, 'Vin Number')) ? <th className="text-muted small">VIN</th> : null}
                              <span className="text-decoration-underline fontsize85 text-primary cursor">
                              </span>
                            </tr>
                          </thead>
                          <tbody>
                            {paymentResponse?.vehicleList ? paymentResponse?.vehicleList.map((v, i) => {

                              return (
                                <tr key={i}>
                                  <td>
                                    <p className="mb-0 ms-2 fontsize85">{v?.license_plate_number}</p>
                                  </td>
                                  <td>
                                    <p className="mb-0 fontsize85">{v?.make}</p>
                                  </td>
                                  {(allHaveMst_model) ? <td>
                                    <p className="mb-0 fontsize85">{v?.model}</p>
                                  </td> : null}
                                  {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td>
                                    <p className="mb-0 fontsize85">{v?.vehicle_type ? v?.vehicle_type : '-'}</p>
                                  </td> : ''}
                                  <td>
                                    <p className="mb-0 fontsize85">{v?.color}</p>
                                  </td>
                                  {isPermissionExist(accessPermissions, 'Get Vehicle Style') ? <td>
                                    <p className="mb-0 fontsize85">{v?.style}</p>
                                  </td> : null}
                                  <td>
                                    <p className="mb-0 fontsize85">{v?.state_code}</p>
                                  </td>

                                  {(isPermissionExist(accessPermissions, 'Vin Number')) && <td>
                                    <p className="mb-0 fontsize85">{v?.vehicle_number}</p>
                                  </td>}
                                </tr>)
                            }) : 'Data Not Found!'}
                          </tbody>
                        </table>
                      </span>
                    </div>
                  </div>
                </div>
                {paymentResponse?.drivers && paymentResponse?.drivers?.length > 0 ? <div className="row">
                  <div className="col-12 row">
                    <div className="col-12">
                      <span className="fontsize85">
                        <b>Upload Documents:</b>
                      </span>
                    </div>
                    <div className='px-4'>
                      <table cellSpacing="0px" cellPadding="0" className="table">
                        <thead>
                          <tr className="small">
                            <th className="text-muted small">Driver Name</th>
                            <th className="text-muted small">Documents</th>
                            <span className="text-decoration-underline fontsize85 text-primary cursor">
                            </span>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentResponse?.drivers && paymentResponse?.drivers?.length > 0 ? paymentResponse?.drivers?.map((v, i) => {

                            return (
                              <tr key={i}>
                                <td>
                                  <p className="mb-0 ms-2 fontsize85">{v?.driver_name}</p>
                                </td>

                                <td>
                                  <p className="mb-0 fontsize85">{v?.url ? <a href={v?.url} target="_blank" rel="noreferrer" className="fw-bold">View</a> : '-'}
                                  </p>
                                </td>
                              </tr>)
                          }) : 'Data Not Found!'}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div> : null}
              </div>

          </div> :
          <div className=" text-center mb-4 ">
            <h1 className="text-center text-danger fw-bold p-3">Booking Failed!  </h1>
            <h5 className="fw-normal p-3 text-danger">{response ? response : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}</h5>

            <div className="text-success bg-opacity-25 p-3">
              <button type="button" className="btn btn-primary " onClick={(e) => handleReBooking(e)}>Book Another {bookingType}</button>
            </div>
          </div>}

        {/* old */}
        <div className="mt-3 d-none">
          <div className="col-sm-10">
            {paymentStatus ? <div className="card my-card text-center">
              <h1 className="text-center text-success fw-bold p-3">{paymentStatus ? 'Thank You!' : 'Error!'}</h1>
              {!paymentStatus && <h4 className="text-center text-success fw-bold p-3">Booking Failed.</h4>}
              <h5 className="fw-normal p-3">{paymentResponse ? 'Your Parking ' + bookingType + ' #' + paymentResponse?.account_number + ' has been created and issued for the period' : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
              </h5>
              <div className="text-success bg-opacity-10 p-3"><h3 >{paymentResponse ? `${moment(paymentResponse?.desired_start_date, 'YYYY/MM/DD').format('MM/DD/YYYY')} - ${moment(paymentResponse?.desired_end_date, 'YYYY/MM/DD').format('MM/DD/YYYY')}` : ''}</h3></div>

              {paymentSession && Object.keys(paymentSession)?.length > 0 ? <div className="text-center">
                <p><b>Please note the following for your reference:</b></p>
                <p><b>Amount:</b> ${paymentResponse?.transaction?.total ? formatDecimal(paymentResponse?.transaction?.total) : paymentSession?.amount ? formatDecimal(paymentSession?.amount) : formatDecimal(0)}</p>
                {paymentResponse ? <p><b>Permit ID:</b> {paymentResponse?.account_number}<br />
                  <b>Permit Type:</b> {paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</p>
                  :
                  <span><p><b>Reference ID:</b> {paymentSession?.reference}</p>
                    <p><b>Transaction ID:</b> {queries?.TxID}</p></span>
                }
              </div> : null}

              <div className="text-success bg-opacity-25 p-3">
                {/* <p>
                  {paymentResponse ? `Your e-${bookingType} details have been sent to your registered phone number ${phoneMasker(paymentResponse?.userDetails?.user ? paymentResponse?.userDetails?.user?.phone_number : paymentResponse?.userDetails?.phone_number)} & email address ${paymentResponse?.email}.` : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
                </p> */}
                <p className='alert alert-success text-center' >
                  {paymentResponse ? `Your e-${bookingType} details have been sent to your ${isphone && isphone != '' ? `phone number ${phoneMasker(isphone)} &` : ''} email address ${paymentResponse?.email}.` : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
                </p>
                {partner == 'demo-parkengage' ? <h4 className='fw-bold text-dark'>This Permit is Valid in Zone {zone} from 9 am to 3 pm<br />
                  You maybe cited if Parking in Zone {zone} Outside those hours</h4> : null}
                <button type="button" className="btn btn-primary " onClick={(e) => handleReBooking(e)}>Book Another {bookingType}</button>
              </div>
            </div> :
              <div className="card text-center mb-4 ">
                <h1 className="text-center text-danger fw-bold p-3">Booking Failed! </h1>
                <h5 className="fw-normal p-3 text-danger">{response ? response : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}</h5>
                {paymentSession && Object.keys(paymentSession)?.length > 0 ? <div className="text-center">
                  <p><b>Please note the following for your reference:</b></p>
                  <p><b>Amount:</b> ${paymentResponse?.transaction?.total ? formatDecimal(paymentResponse?.transaction?.total) : paymentSession?.amount ? formatDecimal(paymentSession?.amount) : formatDecimal(0)}</p>
                  <p><b>Reference ID:</b> {paymentSession?.reference}</p>
                  <p><b>Transaction ID:</b> {queries?.TxID}</p>
                </div> : null}

                {/* card detilas  */}
                {(CardNumberLast4 && card_type && expiration_date) ? <div className='py-2 border-bottom border-5'>
                  <Row>
                    <Col><b>Card last four :</b> {`XXXXXXXXXXXX${removeDubleComma(CardNumberLast4)}`}</Col>
                    <Col><b>Card type :</b>  <img src={getCardIcon(card_type ? removeDubleComma(card_type) : paymentResponse?.paymentDetails?.card_type ? paymentResponse?.paymentDetails?.card_type : '')} style={{ width: '30px', padding: '0' }} alt="" /> {removeDubleComma(card_type)}</Col>
                    <Col><b>Card expiry:</b>{(expiration_date) ? `${removeDubleComma(expiration_date)?.toString()?.substring(0, 2)}/${removeDubleComma(expiration_date)?.toString()?.substring(2, 4)}` : expiration_date}</Col>
                  </Row>
                </div> : ''}
                <div className="text-success bg-opacity-25 p-3">
                  <button type="button" className="btn btn-primary " onClick={(e) => handleReBooking(e)}>Book Another {bookingType}</button>
                </div>
              </div>}
          </div>
        </div>


      </div>
  )

}

ThankYou.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  events: PropTypes.object,
  loader: PropTypes.bool,
  getCard: PropTypes.func,
  passData: EMPTY_ARRAY,
  setPage: PropTypes.string,
  response: PropTypes.object,
  paymentStatus: PropTypes.bool,
  paymentResponse: PropTypes.object,
  isLoading: PropTypes.bool,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object
}

ThankYou.defaulProps = {
  dispatch: noop,
  data: EMPTY_OBJECT,
  events: EMPTY_OBJECT,
  loader: true,
  getCard: noop,
  passData: EMPTY_ARRAY,
  setPage: undefined,
  response: EMPTY_OBJECT,
  paymentStatus: false,
  paymentResponse: EMPTY_OBJECT,
  isLoading: true,
  notify: noop,
  partnerDetails: EMPTY_OBJECT
}

function mapStateToProps({ paymentReducer }) {
  return {
    data: paymentReducer,
  }
}
export default connect(mapStateToProps)(ThankYou)
